import request from '@/utils/request';

export function channelNumberAPI() {
    return {
        // 列表
        getchanneleList: params => {
            return request({
                url: '/admin/referral/index',
                method: 'get',
                params,
            });
        },
        // 分类列表
        classifyList: params => {
            return request({
                url: '/admin/novel/category/select',
                method: 'get',
                params,
            });
        },
         // 导出
         AddExport: params => {
            return request({
                url: `/admin/referral/export?&ids[]=${params}`,
                method: 'get',
            });
        },
        // 调起
        Turnitup: params => {
            return request({
                url: `/admin/referral/detail`,
                method: 'get',
                params
            });
        },
         // 投放媒体前缀列表
         prefixList: params => {
            return request({
                url: `/admin/referral/channelprefix`,
                method: 'get',
                params
            });
        },
         // 充值模版列表
         RechargeList: params => {
            return request({
                url: `/admin/recharge/template/select`,
                method: 'get',
                params
            });
        },
        //新增
        channelAdded: data => {
            return request({
                url: '/admin/referral/update',
                method: 'post',
                data
            });
        },
        // 详情数据
        detailsList: params => {
            return request({
                url: `/admin/referral/show?id=${params}`,
                method: 'get',
            });
        },
        //
        opepisode: params => {
            return request({
                url: '/admin/referral/opepisode',
                method: 'post',
                params
            });
        },
        //回传规则
        Adselect: params => {
            return request({
                url: `/admin/ad/select?type=${params}`,
                method: 'get',
            });
        },
        //获取渠道预览二维码
        getQrcode: params => {
            return request({
                url: '/admin/referral/getqrcode',
                method: 'get',
                params
            });
        },
    };
}
